import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { RegisterViewService } from './register.view.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { FormGroup } from '@angular/forms';
import { AppService } from '../../app.service';
import { HttpResponse, HttpEventType, HttpHeaderResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { PersonViewService } from '../../PersonComponent/PersonViewComponent/person.view.service';
import { EmployerFormService } from '../../EmployerComponent/EmployerFormComponent/employer.form.service';
import { ProjectViewService } from '../../ProjectComponent/ProjectViewComponent/project.view.service';
import { Countries } from '../../../app/shared/countries/countries';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { ActivatedRoute } from '@angular/router'; 
import { Globals } from '../../globals';
import { AuthenticationService } from '../../auth';

@Component({
    selector: 'register-comp',
    providers: [RegisterViewService, PersonViewService, ConfirmService, Countries, AppService, PersonFormService, EmployerFormService,NgxSmartModalService, ProjectViewService, AuthenticationService], 
    templateUrl: './register.view.component.html',  
    styleUrls: ['../register.component.css']  
})

export class RegisterViewComponent {   
    
    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;
    public uploader: FileUploader = new FileUploader({});
    private attachmentContent: any;
    private showContentForAttachment: Boolean = false;

    private activeComponent: boolean;
    private rk;
    showLoader: Boolean = false;
    showAttBody: Boolean = false;
    private person;
    private employer;
    private project;
    private newAttachment: Boolean = false;

    testKlass: String = "3";
    nationality: String;
    suaDetailsForm: FormGroup;
    suaCompanyForm: FormGroup;
    personDetailsForm: FormGroup;
    id: String;

    constructor(
        private service: RegisterViewService,  
        private personViewService: PersonViewService,
        private ngxSmartModalService: NgxSmartModalService,
        private personService: PersonFormService,
        private sanitizer: DomSanitizer,
        private employerService: EmployerFormService,
        private projectService: ProjectViewService,
        private confirmService: ConfirmService,
        private activatedRoute: ActivatedRoute,
        private location : Location,
        private countries: Countries,
        private appService: AppService,
        private globals: Globals,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated(); 
            this.activeComponent = appService.isComponentActive('registercontrol');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            this.setDefault();  
        }

        /**
         * Initiates form
         */
        setDefault() {
            this.getRegisterControl(this.id); 
        }

        /**
         * Get a specific RK
         * @param rkId Identifier for RK
         */
        getRegisterControl(rkId) {
            this.service.getRkById(rkId)      
            .subscribe(
                data => this.setDataToRk(data),
                error =>  this.showError(error.error),
                () => this.showLoader = false
            );   
        }

        /**
         * Patch values from retrieved RK
         * @param data Retrieved RK
         */
        setDataToRk(data) {
            this.rk = data;
        }

        showError(error) {
            console.log(error);
        }

        back() {
            this.location.back();
        }

        editRk() {
            this.appService.setRoute('registercontrol/edit/' + this.rk.id);
        }

        setRoute(route) {
            this.appService.setRoute(route);
        }

        showAttachment() {
            this.ngxSmartModalService.getModal('attachmentModal').open();
        }

         ngAfterViewInit() {
            this.ngxSmartModalService.getModal('attachmentModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
                // modal is the dismissed modal, so do what you want with it
                this.resetModal();
            });
        }

        resetModal() {
            this.newAttachment = false;
            this.showAttBody = false;
            this.uploader.clearQueue();
        }

        showAttachmentBody() {
            this.showAttBody = true;
        }

        selectFile(event) {
            this.selectedFiles = event.target.files;
        }

        showUploader() {
            this.newAttachment = true;
        }

        getFiles(): FileLikeObject[] {
            return this.uploader.queue.map((fileItem) => {
                return fileItem.file;
            });
        }

        upload() {
            let files = this.getFiles();

            for(let i=0; i < files.length; i++) {
                let formData = new FormData();
                formData.append('file', files[i].rawFile, files[i].name);
                this.personViewService.upload(formData).subscribe(event => {
                    if(event.status != 200) {
                        return;
                    }
                    if(event instanceof HttpResponse) {
                        let rkAttachment = {
                            readableName: files[i].name,                            
                          }
                          this.personViewService.saveAttachment(rkAttachment, "rk", this.rk.id).subscribe(
                              data => this.uploadReady(),
                              error => console.log(error)
                          )
                    }
                })
            }
        }

        renderAttachment(data) {
            var file = new Blob([(data)], {type: 'application/pdf'});
            var fileUrl = URL.createObjectURL(file);
            this.sanitizeUrl(fileUrl);
        }

        sanitizeUrl(url) {
            this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            this.showContentForAttachment = true;
        }

        showAttachedFile(id) {
            this.personViewService.showAttachedFile(id).subscribe(
                data => this.renderAttachment(data),
                error => console.log(error)
            );
        }

        uploadReady() {
            this.getRegisterControl(this.id);
            this.uploader.clearQueue();
            this.newAttachment = false;
        }

        backToOverview() {
            this.newAttachment = false;
        }
}